import { render, staticRenderFns } from "./DeviceActionDetailRow.vue?vue&type=template&id=10ca3e4c"
import script from "./DeviceActionDetailRow.vue?vue&type=script&lang=js"
export * from "./DeviceActionDetailRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports